var map = {
	"./WYSIWYG/orderedlist.svg": "./src/assets/icons/WYSIWYG/orderedlist.svg",
	"./WYSIWYG/unorderedlist.svg": "./src/assets/icons/WYSIWYG/unorderedlist.svg",
	"./activity-heart.svg": "./src/assets/icons/activity-heart.svg",
	"./activity.svg": "./src/assets/icons/activity.svg",
	"./agriculture.svg": "./src/assets/icons/agriculture.svg",
	"./alert-circle.svg": "./src/assets/icons/alert-circle.svg",
	"./alert-triangle.svg": "./src/assets/icons/alert-triangle.svg",
	"./align-horizontal-centre-01.svg": "./src/assets/icons/align-horizontal-centre-01.svg",
	"./align-left.svg": "./src/assets/icons/align-left.svg",
	"./align-vertical-center-01.svg": "./src/assets/icons/align-vertical-center-01.svg",
	"./animated/dot-loader.svg": "./src/assets/icons/animated/dot-loader.svg",
	"./animated/logo-dots-90f.svg": "./src/assets/icons/animated/logo-dots-90f.svg",
	"./animated/logo-line-v2-60f.svg": "./src/assets/icons/animated/logo-line-v2-60f.svg",
	"./animated/logo-line-v2-90f.svg": "./src/assets/icons/animated/logo-line-v2-90f.svg",
	"./animated/stars-animations.svg": "./src/assets/icons/animated/stars-animations.svg",
	"./animated/thinking-asterisk.svg": "./src/assets/icons/animated/thinking-asterisk.svg",
	"./annotation-dots.svg": "./src/assets/icons/annotation-dots.svg",
	"./announcement-02.svg": "./src/assets/icons/announcement-02.svg",
	"./apollo.svg": "./src/assets/icons/apollo.svg",
	"./apparel.svg": "./src/assets/icons/apparel.svg",
	"./arrow-down.svg": "./src/assets/icons/arrow-down.svg",
	"./arrow-left.svg": "./src/assets/icons/arrow-left.svg",
	"./arrow-narrow-left.svg": "./src/assets/icons/arrow-narrow-left.svg",
	"./arrow-right.svg": "./src/assets/icons/arrow-right.svg",
	"./arrow-up.svg": "./src/assets/icons/arrow-up.svg",
	"./arrow.svg": "./src/assets/icons/arrow.svg",
	"./atom-01.svg": "./src/assets/icons/atom-01.svg",
	"./atom-02.svg": "./src/assets/icons/atom-02.svg",
	"./attachment-02.svg": "./src/assets/icons/attachment-02.svg",
	"./bank.svg": "./src/assets/icons/bank.svg",
	"./bar-chart-square-02.svg": "./src/assets/icons/bar-chart-square-02.svg",
	"./beaker-02.svg": "./src/assets/icons/beaker-02.svg",
	"./bell-03-notification.svg": "./src/assets/icons/bell-03-notification.svg",
	"./bell-03.svg": "./src/assets/icons/bell-03.svg",
	"./bold-01.svg": "./src/assets/icons/bold-01.svg",
	"./book-open-check.svg": "./src/assets/icons/book-open-check.svg",
	"./bookmark-v2-clicked.svg": "./src/assets/icons/bookmark-v2-clicked.svg",
	"./bookmark-v2.svg": "./src/assets/icons/bookmark-v2.svg",
	"./bookmark.svg": "./src/assets/icons/bookmark.svg",
	"./bot.svg": "./src/assets/icons/bot.svg",
	"./brain.svg": "./src/assets/icons/brain.svg",
	"./briefcase-01.svg": "./src/assets/icons/briefcase-01.svg",
	"./brush-01.svg": "./src/assets/icons/brush-01.svg",
	"./building-02.svg": "./src/assets/icons/building-02.svg",
	"./building-07.svg": "./src/assets/icons/building-07.svg",
	"./building-08.svg": "./src/assets/icons/building-08.svg",
	"./building-2.svg": "./src/assets/icons/building-2.svg",
	"./calendar-check-01.svg": "./src/assets/icons/calendar-check-01.svg",
	"./calendar.svg": "./src/assets/icons/calendar.svg",
	"./car-01.svg": "./src/assets/icons/car-01.svg",
	"./check-circle.svg": "./src/assets/icons/check-circle.svg",
	"./check.svg": "./src/assets/icons/check.svg",
	"./chevron-down-double.svg": "./src/assets/icons/chevron-down-double.svg",
	"./chevron-down.svg": "./src/assets/icons/chevron-down.svg",
	"./chevron-left-double.svg": "./src/assets/icons/chevron-left-double.svg",
	"./chevron-left.svg": "./src/assets/icons/chevron-left.svg",
	"./chevron-right-double.svg": "./src/assets/icons/chevron-right-double.svg",
	"./chevron-right.svg": "./src/assets/icons/chevron-right.svg",
	"./chevron-up-double.svg": "./src/assets/icons/chevron-up-double.svg",
	"./chevron-up.svg": "./src/assets/icons/chevron-up.svg",
	"./circle-help.svg": "./src/assets/icons/circle-help.svg",
	"./clipboard-check.svg": "./src/assets/icons/clipboard-check.svg",
	"./clipboard.svg": "./src/assets/icons/clipboard.svg",
	"./clock.svg": "./src/assets/icons/clock.svg",
	"./code-browser.svg": "./src/assets/icons/code-browser.svg",
	"./coins-stacked-03.svg": "./src/assets/icons/coins-stacked-03.svg",
	"./collapse-06.svg": "./src/assets/icons/collapse-06.svg",
	"./compass-03.svg": "./src/assets/icons/compass-03.svg",
	"./container.svg": "./src/assets/icons/container.svg",
	"./content.svg": "./src/assets/icons/content.svg",
	"./copy-01.svg": "./src/assets/icons/copy-01.svg",
	"./copy-07.svg": "./src/assets/icons/copy-07.svg",
	"./copy.svg": "./src/assets/icons/copy.svg",
	"./cpu-chip-01.svg": "./src/assets/icons/cpu-chip-01.svg",
	"./csv-icon.svg": "./src/assets/icons/csv-icon.svg",
	"./cube-02.svg": "./src/assets/icons/cube-02.svg",
	"./cup.svg": "./src/assets/icons/cup.svg",
	"./custom/circle-check.svg": "./src/assets/icons/custom/circle-check.svg",
	"./custom/circle-dot-gray.svg": "./src/assets/icons/custom/circle-dot-gray.svg",
	"./custom/circle-dot-green.svg": "./src/assets/icons/custom/circle-dot-green.svg",
	"./custom/cursor.svg": "./src/assets/icons/custom/cursor.svg",
	"./custom/file-drop.svg": "./src/assets/icons/custom/file-drop.svg",
	"./custom/g-logo-fat.svg.svg": "./src/assets/icons/custom/g-logo-fat.svg.svg",
	"./custom/logo9.svg": "./src/assets/icons/custom/logo9.svg",
	"./custom/max-icon.svg": "./src/assets/icons/custom/max-icon.svg",
	"./database-02.svg": "./src/assets/icons/database-02.svg",
	"./dataflow-02.svg": "./src/assets/icons/dataflow-02.svg",
	"./dataflow-04.svg": "./src/assets/icons/dataflow-04.svg",
	"./delete.svg": "./src/assets/icons/delete.svg",
	"./diamond-01.svg": "./src/assets/icons/diamond-01.svg",
	"./doc-icon.svg": "./src/assets/icons/doc-icon.svg",
	"./dot.svg": "./src/assets/icons/dot.svg",
	"./dots-horizontal.svg": "./src/assets/icons/dots-horizontal.svg",
	"./dots-vertical.svg": "./src/assets/icons/dots-vertical.svg",
	"./download-02.svg": "./src/assets/icons/download-02.svg",
	"./download-04.svg": "./src/assets/icons/download-04.svg",
	"./download.svg": "./src/assets/icons/download.svg",
	"./edit-03.svg": "./src/assets/icons/edit-03.svg",
	"./edit-04.svg": "./src/assets/icons/edit-04.svg",
	"./edit-05.svg": "./src/assets/icons/edit-05.svg",
	"./ellipse.svg": "./src/assets/icons/ellipse.svg",
	"./ellipsis-01.svg": "./src/assets/icons/ellipsis-01.svg",
	"./email.svg": "./src/assets/icons/email.svg",
	"./empty.svg": "./src/assets/icons/empty.svg",
	"./enter.svg": "./src/assets/icons/enter.svg",
	"./event-icon.svg": "./src/assets/icons/event-icon.svg",
	"./expand-05.svg": "./src/assets/icons/expand-05.svg",
	"./expand-06.svg": "./src/assets/icons/expand-06.svg",
	"./external-link.svg": "./src/assets/icons/external-link.svg",
	"./feather.svg": "./src/assets/icons/feather.svg",
	"./feed-01.svg": "./src/assets/icons/feed-01.svg",
	"./file-02.svg": "./src/assets/icons/file-02.svg",
	"./file-04.svg": "./src/assets/icons/file-04.svg",
	"./file-06.svg": "./src/assets/icons/file-06.svg",
	"./file-07.svg": "./src/assets/icons/file-07.svg",
	"./file-blue.svg": "./src/assets/icons/file-blue.svg",
	"./file-box.svg": "./src/assets/icons/file-box.svg",
	"./file-download-03.svg": "./src/assets/icons/file-download-03.svg",
	"./file-plus-02.svg": "./src/assets/icons/file-plus-02.svg",
	"./file-text.svg": "./src/assets/icons/file-text.svg",
	"./file-type.svg": "./src/assets/icons/file-type.svg",
	"./file.svg": "./src/assets/icons/file.svg",
	"./filter-funnel-01.svg": "./src/assets/icons/filter-funnel-01.svg",
	"./filter-lines-notification.svg": "./src/assets/icons/filter-lines-notification.svg",
	"./filter-lines.svg": "./src/assets/icons/filter-lines.svg",
	"./filter-x.svg": "./src/assets/icons/filter-x.svg",
	"./flag-01.svg": "./src/assets/icons/flag-01.svg",
	"./flag.svg": "./src/assets/icons/flag.svg",
	"./flask-conical.svg": "./src/assets/icons/flask-conical.svg",
	"./flip-backward.svg": "./src/assets/icons/flip-backward.svg",
	"./flip-forward.svg": "./src/assets/icons/flip-forward.svg",
	"./g-logo.svg": "./src/assets/icons/g-logo.svg",
	"./git-merge.svg": "./src/assets/icons/git-merge.svg",
	"./globe-02.svg": "./src/assets/icons/globe-02.svg",
	"./globe-04.svg": "./src/assets/icons/globe-04.svg",
	"./globe.svg": "./src/assets/icons/globe.svg",
	"./graduation-hat-02.svg": "./src/assets/icons/graduation-hat-02.svg",
	"./handshake.svg": "./src/assets/icons/handshake.svg",
	"./hard-drive.svg": "./src/assets/icons/hard-drive.svg",
	"./hash-02-a.svg": "./src/assets/icons/hash-02-a.svg",
	"./hash-02.svg": "./src/assets/icons/hash-02.svg",
	"./hash.svg": "./src/assets/icons/hash.svg",
	"./help-circle.svg": "./src/assets/icons/help-circle.svg",
	"./home-02.svg": "./src/assets/icons/home-02.svg",
	"./home-line.svg": "./src/assets/icons/home-line.svg",
	"./hourglass.svg": "./src/assets/icons/hourglass.svg",
	"./icon-03.svg": "./src/assets/icons/icon-03.svg",
	"./indicator.svg": "./src/assets/icons/indicator.svg",
	"./info.svg": "./src/assets/icons/info.svg",
	"./italic-01.svg": "./src/assets/icons/italic-01.svg",
	"./keyboard-02.svg": "./src/assets/icons/keyboard-02.svg",
	"./layers-three-01.svg": "./src/assets/icons/layers-three-01.svg",
	"./library.svg": "./src/assets/icons/library.svg",
	"./life-buoy-01.svg": "./src/assets/icons/life-buoy-01.svg",
	"./life-buoy-02.svg": "./src/assets/icons/life-buoy-02.svg",
	"./lightbulb-02.svg": "./src/assets/icons/lightbulb-02.svg",
	"./lightning-01.svg": "./src/assets/icons/lightning-01.svg",
	"./link-01.svg": "./src/assets/icons/link-01.svg",
	"./link-external-01.svg": "./src/assets/icons/link-external-01.svg",
	"./list.svg": "./src/assets/icons/list.svg",
	"./loader.svg": "./src/assets/icons/loader.svg",
	"./lock-01.svg": "./src/assets/icons/lock-01.svg",
	"./log-out-01.svg": "./src/assets/icons/log-out-01.svg",
	"./logomark.svg": "./src/assets/icons/logomark.svg",
	"./luggage-02.svg": "./src/assets/icons/luggage-02.svg",
	"./mail-02.svg": "./src/assets/icons/mail-02.svg",
	"./mail-question.svg": "./src/assets/icons/mail-question.svg",
	"./mail-warning.svg": "./src/assets/icons/mail-warning.svg",
	"./mark.svg": "./src/assets/icons/mark.svg",
	"./marker-pin-01.svg": "./src/assets/icons/marker-pin-01.svg",
	"./medal.svg": "./src/assets/icons/medal.svg",
	"./medical-cross.svg": "./src/assets/icons/medical-cross.svg",
	"./menu-03.svg": "./src/assets/icons/menu-03.svg",
	"./menu-04.svg": "./src/assets/icons/menu-04.svg",
	"./message-alert-square.svg": "./src/assets/icons/message-alert-square.svg",
	"./message-chat-circle.svg": "./src/assets/icons/message-chat-circle.svg",
	"./message-check-square.svg": "./src/assets/icons/message-check-square.svg",
	"./message-smile-circle.svg": "./src/assets/icons/message-smile-circle.svg",
	"./message-square-text.svg": "./src/assets/icons/message-square-text.svg",
	"./message-text-circle-02.svg": "./src/assets/icons/message-text-circle-02.svg",
	"./message-text-square-02.svg": "./src/assets/icons/message-text-square-02.svg",
	"./message-x-square.svg": "./src/assets/icons/message-x-square.svg",
	"./microphone-01.svg": "./src/assets/icons/microphone-01.svg",
	"./minus.svg": "./src/assets/icons/minus.svg",
	"./north-star.svg": "./src/assets/icons/north-star.svg",
	"./open-quote.svg": "./src/assets/icons/open-quote.svg",
	"./package-open.svg": "./src/assets/icons/package-open.svg",
	"./package-plus.svg": "./src/assets/icons/package-plus.svg",
	"./package-rounded.svg": "./src/assets/icons/package-rounded.svg",
	"./passcode-lock.svg": "./src/assets/icons/passcode-lock.svg",
	"./pause.svg": "./src/assets/icons/pause.svg",
	"./pencil-01.svg": "./src/assets/icons/pencil-01.svg",
	"./pencil-02.svg": "./src/assets/icons/pencil-02.svg",
	"./pencil.svg": "./src/assets/icons/pencil.svg",
	"./phone.svg": "./src/assets/icons/phone.svg",
	"./pin-01.svg": "./src/assets/icons/pin-01.svg",
	"./pin-02.svg": "./src/assets/icons/pin-02.svg",
	"./play.svg": "./src/assets/icons/play.svg",
	"./plus.svg": "./src/assets/icons/plus.svg",
	"./podcast-player.svg": "./src/assets/icons/podcast-player.svg",
	"./podcast.svg": "./src/assets/icons/podcast.svg",
	"./presentation-chart-01.svg": "./src/assets/icons/presentation-chart-01.svg",
	"./printer.svg": "./src/assets/icons/printer.svg",
	"./puzzle-piece-02.svg": "./src/assets/icons/puzzle-piece-02.svg",
	"./refresh-cw-01.svg": "./src/assets/icons/refresh-cw-01.svg",
	"./refresh-cw-05.svg": "./src/assets/icons/refresh-cw-05.svg",
	"./refresh-cw-09.svg": "./src/assets/icons/refresh-cw-09.svg",
	"./resize-handle.svg": "./src/assets/icons/resize-handle.svg",
	"./save-01.svg": "./src/assets/icons/save-01.svg",
	"./scroll-text.svg": "./src/assets/icons/scroll-text.svg",
	"./search-md.svg": "./src/assets/icons/search-md.svg",
	"./search.svg": "./src/assets/icons/search.svg",
	"./send-01.svg": "./src/assets/icons/send-01.svg",
	"./send-02.svg": "./src/assets/icons/send-02.svg",
	"./send-03.svg": "./src/assets/icons/send-03.svg",
	"./separator.svg": "./src/assets/icons/separator.svg",
	"./settings-01.svg": "./src/assets/icons/settings-01.svg",
	"./settings-02.svg": "./src/assets/icons/settings-02.svg",
	"./share-01.svg": "./src/assets/icons/share-01.svg",
	"./share-02.svg": "./src/assets/icons/share-02.svg",
	"./share-06.svg": "./src/assets/icons/share-06.svg",
	"./share.svg": "./src/assets/icons/share.svg",
	"./shopping-bag-02.svg": "./src/assets/icons/shopping-bag-02.svg",
	"./shorter.svg": "./src/assets/icons/shorter.svg",
	"./signal-02.svg": "./src/assets/icons/signal-02.svg",
	"./social/Social icon.svg": "./src/assets/icons/social/Social icon.svg",
	"./social/celebrate.svg": "./src/assets/icons/social/celebrate.svg",
	"./social/comment.svg": "./src/assets/icons/social/comment.svg",
	"./social/curious.svg": "./src/assets/icons/social/curious.svg",
	"./social/facebook.svg": "./src/assets/icons/social/facebook.svg",
	"./social/google-logo.svg": "./src/assets/icons/social/google-logo.svg",
	"./social/insightfull.svg": "./src/assets/icons/social/insightfull.svg",
	"./social/like-2.svg": "./src/assets/icons/social/like-2.svg",
	"./social/like.svg": "./src/assets/icons/social/like.svg",
	"./social/linkedin-circle.svg": "./src/assets/icons/social/linkedin-circle.svg",
	"./social/linkedin.svg": "./src/assets/icons/social/linkedin.svg",
	"./social/love.svg": "./src/assets/icons/social/love.svg",
	"./social/send.svg": "./src/assets/icons/social/send.svg",
	"./social/share.svg": "./src/assets/icons/social/share.svg",
	"./social/support.svg": "./src/assets/icons/social/support.svg",
	"./social/twitter.svg": "./src/assets/icons/social/twitter.svg",
	"./sources/analysys-mason.svg": "./src/assets/icons/sources/analysys-mason.svg",
	"./sources/apollo.svg": "./src/assets/icons/sources/apollo.svg",
	"./sources/appledore.svg": "./src/assets/icons/sources/appledore.svg",
	"./sources/global-data.svg": "./src/assets/icons/sources/global-data.svg",
	"./sources/omdia.svg": "./src/assets/icons/sources/omdia.svg",
	"./sources/sales-point.svg": "./src/assets/icons/sources/sales-point.svg",
	"./sources/tbr.svg": "./src/assets/icons/sources/tbr.svg",
	"./spacing-width-01.svg": "./src/assets/icons/spacing-width-01.svg",
	"./spark-1.svg": "./src/assets/icons/spark-1.svg",
	"./spinner.svg": "./src/assets/icons/spinner.svg",
	"./square-01.svg": "./src/assets/icons/square-01.svg",
	"./square-plus.svg": "./src/assets/icons/square-plus.svg",
	"./star-01.svg": "./src/assets/icons/star-01.svg",
	"./star-04.svg": "./src/assets/icons/star-04.svg",
	"./star-06.svg": "./src/assets/icons/star-06.svg",
	"./stars-02-brand.svg": "./src/assets/icons/stars-02-brand.svg",
	"./stars-02-secondary.svg": "./src/assets/icons/stars-02-secondary.svg",
	"./stars-02.svg": "./src/assets/icons/stars-02.svg",
	"./stars-03.svg": "./src/assets/icons/stars-03.svg",
	"./stop.svg": "./src/assets/icons/stop.svg",
	"./tag.svg": "./src/assets/icons/tag.svg",
	"./target-02.svg": "./src/assets/icons/target-02.svg",
	"./target-04.svg": "./src/assets/icons/target-04.svg",
	"./target-05.svg": "./src/assets/icons/target-05.svg",
	"./target-l.svg": "./src/assets/icons/target-l.svg",
	"./target-m.svg": "./src/assets/icons/target-m.svg",
	"./target-s.svg": "./src/assets/icons/target-s.svg",
	"./target.svg": "./src/assets/icons/target.svg",
	"./telescope.svg": "./src/assets/icons/telescope.svg",
	"./thumbs-down.svg": "./src/assets/icons/thumbs-down.svg",
	"./thumbs-up.svg": "./src/assets/icons/thumbs-up.svg",
	"./tool-01.svg": "./src/assets/icons/tool-01.svg",
	"./tool-02.svg": "./src/assets/icons/tool-02.svg",
	"./tram.svg": "./src/assets/icons/tram.svg",
	"./trash-01.svg": "./src/assets/icons/trash-01.svg",
	"./trash-04.svg": "./src/assets/icons/trash-04.svg",
	"./trash-2.svg": "./src/assets/icons/trash-2.svg",
	"./trend-down-01.svg": "./src/assets/icons/trend-down-01.svg",
	"./trend-up-01.svg": "./src/assets/icons/trend-up-01.svg",
	"./triangle-alert.svg": "./src/assets/icons/triangle-alert.svg",
	"./truck-02.svg": "./src/assets/icons/truck-02.svg",
	"./tv-03.svg": "./src/assets/icons/tv-03.svg",
	"./umbrella-02.svg": "./src/assets/icons/umbrella-02.svg",
	"./upload-02.svg": "./src/assets/icons/upload-02.svg",
	"./upload-cloud-02.svg": "./src/assets/icons/upload-cloud-02.svg",
	"./upload.svg": "./src/assets/icons/upload.svg",
	"./user-02.svg": "./src/assets/icons/user-02.svg",
	"./user-03.svg": "./src/assets/icons/user-03.svg",
	"./user-plus.svg": "./src/assets/icons/user-plus.svg",
	"./user.svg": "./src/assets/icons/user.svg",
	"./users-02.svg": "./src/assets/icons/users-02.svg",
	"./users.svg": "./src/assets/icons/users.svg",
	"./virus.svg": "./src/assets/icons/virus.svg",
	"./volume-minus.svg": "./src/assets/icons/volume-minus.svg",
	"./volume-plus.svg": "./src/assets/icons/volume-plus.svg",
	"./volume-x.svg": "./src/assets/icons/volume-x.svg",
	"./wand-sparkles.svg": "./src/assets/icons/wand-sparkles.svg",
	"./x-circle.svg": "./src/assets/icons/x-circle.svg",
	"./x-close-thin.svg": "./src/assets/icons/x-close-thin.svg",
	"./x-close.svg": "./src/assets/icons/x-close.svg",
	"./x.svg": "./src/assets/icons/x.svg",
	"./zap-fast.svg": "./src/assets/icons/zap-fast.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons sync recursive \\.svg$";